<template>
  <!--<Toast></Toast>-->
</template>

<script>
import { Toast } from 'vant'
export default {
  name: 'toast',
  components: {
    Toast
  },
  data () {
    return {
      msg: '',
      time: 2000
    }
  },
  methods: {
    showFun (data) {
      let me = this
      for (var item in data) {
        me[item] = data[item]
      }
      me.$toast({
        message: me.msg,
        mask: false,

        forbidClick: true,
        duration: me.time
      })
    },
    showLoading: function (data) {
      let me = this
      for (var item in data) {
        me[item] = data[item]
      }
      me.$toast.loading({
        message: me.msg,
        mask: false,
        forbidClick: true,
        duration: 0
      })
    },
    clear () {
      this.$toast.clear()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/toast/toast.vue